/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const getErrorMessage = (error: any): string => error.response?.data?.message || error.message || JSON.stringify(error);
